import { Badge } from '@thegpvc/ui';
import { shouldBadgeSource, sourceLabel } from '../utils/sourceLabels';

interface SourceBadgeProps {
  source?: string;
  size?: 'sm' | 'md';
}

/**
 * SourceBadge marks a session's log source (#660). Claude Code is the default
 * and renders nothing — only non-default sources (e.g. Codex) get a badge so
 * they are identifiable at a glance without the default source shouting on
 * every row. The taxonomy lives in utils/sourceLabels.ts.
 */
export function SourceBadge({ source, size = 'sm' }: SourceBadgeProps) {
  if (!shouldBadgeSource(source)) return null;
  const label = sourceLabel(source!);
  // The badge encodes the source via text + color; the "Source:" context lives
  // only in the mouse `title` tooltip, which assistive tech ignores. Expose it
  // as an accessible name with `role="img"` + `aria-label` (the same string as
  // the title, so they can't drift) — the pattern the SessionTable signal pills
  // use. See the dashboard-accessibility-conventions memory topic.
  return (
    <span role="img" aria-label={`Source: ${label}`} title={`Source: ${label}`} className="inline-flex">
      <Badge variant="info" size={size}>
        {label}
      </Badge>
    </span>
  );
}
